export default __webpack_public_path__ + "static/media/Doctor.9d5595e5.svg";